export default import.meta.ROLLDOWN_FILE_URL_Sfg2N5ST60QWT3Jm56o_yg